import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import logo from "../../../assets/logo.svg";
import { Col, Row } from "antd";
import Button from "../../../common/Button";
import { BASE_URL, SEND_OTP_ENDPOINT, StaffRoleListEndPoint, VERIFY_OTP_ENDPOINT } from "../../../utils/constant";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';
import { useDispatch, useSelector } from "react-redux";
import { setUserInformation } from "../../../store/slices/signUpSlice";

function VerifyOtpLogin() {
  const [otp, setOtp] = useState(["", "", "", "", ""]);
  const signUpDetails = useSelector((state) => state.signUp.signUpDetails);
  const dispatch = useDispatch();

  const navigate = useNavigate();
console.log('signUpDetails',signUpDetails)
  //take otp from user
  const handleOtpChange = (index, value, type, event) => {
    
    if (event.key === "Enter" ) {
      handleOtpVerify()
    }
    if (event.key === "Backspace" && value === "") {
      // If backspace is pressed and the current input is empty, move focus to the previous input field
      if (index > 0) {
        document.getElementById(`otp-input-mobile-${index - 1}`).focus();
      }
    } else if (/^\d{0,1}$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      if (type === "mobile") setOtp(newOtp);
      if (value !== "" && index < 4) {
        // Move focus to the next input field
        document.getElementById(`otp-input-mobile-${index + 1}`).focus();
      }
    }
  };
  const resendOtp = () => {
    console.log('signUpDetails.phoneNumber',sessionStorage.getItem('verifyNumber'))
   let otpSentTo = {
      sendTo: sessionStorage.getItem('verifyNumber')

    }
    console.log('otpSentTo',otpSentTo)
    const token = localStorage.getItem('verifyToken');

    const fetchData = async () => {
      const response = await fetch(`${BASE_URL}/${SEND_OTP_ENDPOINT}`, {
        method: "POST",
        headers: {
                  'Content-Type': 'application/json',
                  'Authorization': `${token}`,
                  
                },
        body: JSON.stringify(otpSentTo),
      });

      if (response.ok) {
        const data = await response.json();


        console.log('resendOtp',data)
        toast.success("Otp sent!", {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        const data = await response.json();
        console.log('resendOtperr',data)
          toast.error(data.errorMessage, {
            position: toast.POSITION.TOP_RIGHT,
          });
         
     }
     };
     fetchData();
  };
  const handleOtpVerify = () => {
    let otpObject ={}
    const joinedOTP = otp.map(num => num.toString()).join('');
    console.log('joinedOTP',joinedOTP)

    if(otp){
      otpObject =  {
        key: "mobile",
        otp:joinedOTP,
        deviceType:"android",
      }
    }
    
    console.log('otpObject',otpObject)
    const token = localStorage.getItem('verifyToken');
      // const parseToken = JSON.parse(token) || {};
    const fetchData = async () => {
      const response = await fetch(`${BASE_URL}/${VERIFY_OTP_ENDPOINT}`, {
        method: "POST",
        headers: {
                  'Content-Type': 'application/json',
                  'Authorization': `${token}`,
                  
                },
        body: JSON.stringify(otpObject),
      });

      console.log('CompanyData')
      if (response.ok) {
        const data = await response.json();
        localStorage.removeItem("verifyToken");
        sessionStorage.removeItem('verifyNumber')
        localStorage.setItem("authToken", data?.data?.authToken);
        dispatch(setUserInformation(data?.data));
        console.log('CompanyData',data)
        toast.success("Login Successfully", {
          position: toast.POSITION.TOP_RIGHT,
        });
        navigate("/dashboard");
        // getStaffRoleList();
        
      } else {
        const data = await response.json();
        console.log('CompanyDataerr',data)
          toast.error(data.errorMessage, {
            position: toast.POSITION.TOP_RIGHT,
          });
         
     }
     };
     fetchData();
  };
  // const getStaffRoleList = async () =>{
  //   const fetchData = async () => {
  //     const response = await fetch(`${BASE_URL}/${StaffRoleListEndPoint}`, {
  //       method: "POST",
  //       headers: {
  //         'Content-Type': 'application/json',
  //       },
  //       body: JSON.stringify({
  //       }),
  //     });
      
  //     if (response.ok) {
  //       const data = await response.json();
       
  //       console.log('CompanyData',data)
  //       const extractedData = data.data.map(({ uniqueId, roleId }) => ({ uniqueId, roleId }));

  //       localStorage.setItem("roles",JSON.stringify(extractedData));

        
  //     } else {
  //       const data = await response.json();
  //       console.log('CompanyDataerr',data)
        
        
  //     }
  //   };
  //   fetchData();
  // }
  return (
    <>
    <ToastContainer position="top-right" autoClose={2000} />
      <div className="h-full">
        <Row className="h-full">
          <Col lg={10}>
            <div className="h-full flex items-center justify-center bg-loginBg bg-no-repeat bg-cover">
              <div className="w-[430px] h-[430px] bg-[rgba(255,255,255,.04)] rounded-full absolute"></div>
              <img className="z-1 relative" src={logo} alt="_blank" />
            </div>
          </Col>
          <Col lg={14} className="bg-[#F5FBFE] h-full">
            <div className="flex flex-col h-full items-center login-part-back py-11 overflow-auto justify-center">
              <div className="flex flex-col justify-end items-center gap-y-1.5 w-[440px]">
                <div className="flex justify-center flex-col text-center">
                  <span className="text-3xl font-bold mb-2">
                    OTP Verification
                  </span>
                </div>
                <div className="inline-flex flex-col mx-auto mb-3">
                  <div className="font-bold text-[17px] mt-5">
                    Enter OTP sent on mobile
                  </div>
                  <div class="flex flex-row -mx-2">
                    {otp.map((digit, index) => (
                     <input
                     key={index}
                     id={`otp-input-mobile-${index}`}
                     type="text"
                     value={digit}
                     onChange={(e) =>
                       handleOtpChange(index, e.target.value, "mobile", e)
                     }
                     onKeyDown={(e) =>
                       handleOtpChange(index, e.target.value, "mobile", e)
                     }
                     maxLength={1}
                     placeholder={index}
                     className="m-2 border h-[3.2rem] w-[3.35rem] rounded-xl border-none bg-[#4B8AEB24] outline-none text-center text-2xl"
                   />
                    ))}
                  </div>
                </div>
                <div className="inline-flex flex-col mx-auto mb-3">
                  
                  <Button label="Verify" onSubmit={handleOtpVerify} />
                  <div className="flex justify-center mt-10">
                    Didn't received?{" "}
                    <span onClick={resendOtp} className="font-bold ml-1 cursor-pointer">
                      Resend Now
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default VerifyOtpLogin;
